import Api from "../../Utils/Api";
import { successNotify } from "../../Utils/Toast";

export const loginUser = (formData) => async (dispatch) => {
    try {
        dispatch({
            type: "LOGIN_REQUEST",
        });

        const { data } = await Api.post("auth/login", formData);

        if (data.statusCode === 200) {
            localStorage.setItem("tmsToken", data.data.token);
            localStorage.setItem("tmsUserDetail", JSON.stringify(data.data.user_details));

            dispatch({
                type: "LOGIN_SUCCESS",
                payload: data.data,
                success: true,
            });

            successNotify("Login Successful!");
        }
    } catch (e) {
        dispatch({
            type: "LOGIN_FAILED",
            payload: e?.response?.data?.message[0],
            success: false,
        });
    }
};

export const signUpUser = (formData) => async (dispatch) => {
    try {
        dispatch({ type: "SIGNUP_REQUEST" });

        const { data } = await Api.post("auth/sign-up", formData);

        dispatch({ type: "SIGNUP_SUCCESS", payload: data, success: true });
        
    } catch (e) {
        dispatch({
            type: "SIGNUP_FAILED",
            payload: e?.response?.data?.message[0],
            success: false
        });
    }
};

export const forgotPassword = (formData) => async (dispatch) => {
    try {
        dispatch({ type: "FORGOT_PASSWORD_REQUEST" });

        const { data } = await Api.post("auth/recovery-password", formData);

        dispatch({ type: "FORGOT_PASSWORD_SUCCESS", payload: data, success: true });
        
    } catch (e) {
        dispatch({
            type: "FORGOT_PASSWORD_FAILED",
            payload: e?.response?.data?.message[0],
            success: false
        });
    }
};

export const resetPassword = (formData) => async (dispatch) => {
    try {
        dispatch({ type: "RESET_PASSWORD_REQUEST" });

        const { data } = await Api.patch("auth/set-new-password", formData);

        dispatch({ type: "RESET_PASSWORD_SUCCESS", payload: data, success: true });

    } catch (e) {
        dispatch({
            type: "RESET_PASSWORD_FAILED",
            payload: e?.response?.data?.message[0],
            success: false
        });
    }
};